import { useEffect, useState } from 'react';
import { useGameStore } from '../../core/store';
import './run-hud.css';

export function RunHUD() {
  const isTouch =
    typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0;
  const unlocked = useGameStore((s) => s.unlockedSkills);
  const [meters, setMeters] = useState(0);
  const [stamina, setStamina] = useState(1);
  const [combo, setCombo] = useState(1);

  useEffect(() => {
    const id = window.setInterval(() => {
      setMeters((m) => m + 1);
      setStamina((s) => {
        const next = s - 0.008;
        return next < 0.22 ? 0.9 : next;
      });
      setCombo((c) => (unlocked.length > 0 ? Math.min(8, unlocked.length + 1) : c));
    }, 200);
    return () => window.clearInterval(id);
  }, [unlocked.length]);

  const segs = 10;
  const lit = Math.round(stamina * segs);

  return (
    <div className="run-hud">
      <div className="run-hud__tl">
        <div className="run-hud__label">
          <span className="run-hud__bolt" aria-hidden>
            ⚡
          </span>
          STAMINA
        </div>
        <div className="run-hud__stamina" aria-label="Stamina">
          {Array.from({ length: segs }, (_, i) => (
            <span
              key={i}
              className={`run-hud__seg${i < lit ? ' is-on' : ''}${
                i < lit && lit <= 4 ? ' is-low' : ''
              }`}
            />
          ))}
        </div>
      </div>

      <div className="run-hud__tr">
        <p className="run-hud__dist">{meters}m</p>
        <p className={`run-hud__combo${combo > 1 ? ' is-hot' : ''}`}>
          Combo x{combo}
        </p>
      </div>

      <div className="run-hud__crosshair" aria-hidden />

      <div className="run-hud__skills">
        {unlocked.map((id) => (
          <span key={id}>{id}</span>
        ))}
      </div>

      <div className="run-hud__hint">
        {isTouch ? (
          <>
            <span>Left: move</span>
            <span>Right: look</span>
            <span>Swipe L/R: dodge</span>
          </>
        ) : (
          <>
            <span>WASD move</span>
            <span>Mouse look</span>
            <span>Q/E dodge</span>
            <span>Space power</span>
            <span>Click lock</span>
          </>
        )}
      </div>

      {isTouch && (
        <div className="run-hud__zones" aria-hidden>
          <div className="run-hud__zone run-hud__zone--move" />
          <div className="run-hud__zone run-hud__zone--look" />
        </div>
      )}
    </div>
  );
}
